var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIconCampusDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 14.167V13.3337C15.8333 12.4132 16.5795 11.667 17.5 11.667H22.5C23.4205 11.667 24.1667 12.4132 24.1667 13.3337V14.167H26.6667C27.1269 14.167 27.5 14.5401 27.5 15.0003C27.5 15.4606 27.1269 15.8337 26.6667 15.8337H25.8333V25.0003C25.8333 26.381 24.714 27.5003 23.3333 27.5003H16.6667C15.286 27.5003 14.1667 26.381 14.1667 25.0003V15.8337H13.3333C12.8731 15.8337 12.5 15.4606 12.5 15.0003C12.5 14.5401 12.8731 14.167 13.3333 14.167H15.8333ZM17.5 13.3337H22.5V14.167H17.5V13.3337ZM15.8333 15.8337H24.1667V25.0003C24.1667 25.4606 23.7936 25.8337 23.3333 25.8337H16.6667C16.2064 25.8337 15.8333 25.4606 15.8333 25.0003V15.8337Z",
    fill: "#1A3D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.5003H20.8333V24.167H22.5V17.5003Z",
    fill: "#1A3D82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 17.5003H17.5V24.167H19.1667V17.5003Z",
    fill: "#1A3D82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconCampusDisabled);
export default __webpack_public_path__ + "static/media/deleteIconCampusDisabled.31ae82ca9512c51782d12b80703a05fe.svg";
export { ForwardRef as ReactComponent };